import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { ToastService } from "./toast.service";

@Injectable()
export class PlanningPalettesService {

  private base_url = `${environment.API_URL}/planning`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);
  
  constructor(private http: HttpClient, private toast: ToastService) { }

  getPlanningPalettes(planning_id: number) {
    return this.http
      .get(`${this.base_url}/${planning_id}/palettes`, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  updatePalettes(params: any) {
    return this.http
      .patch(this.base_url + "/palettes/update", params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        this.toast.success(
          "Les palettes ont été mises à jour avec succès", false, "Palettes"
        );
        return response;
      
    })
  }
  //update one palette
  updatePalette(palette_id: number, params: object) {
    
    return this.http
      .patch(`${this.base_url}/palettes/${palette_id}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Palette Mise à jour.", false, "Planning");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour des palettes.",
            false,
            "Planning"
          );
        }
      });
  }
  //create one palette
  createPalette(params: object, planning_id: number) {
    params["planning_id"] = planning_id;
    return this.http.post(this.base_url + "/palettes/create", params, {
      headers: this.headers,
    }).map((res) => {
      let response = JSON.parse(JSON.stringify(res));
      this.toast.success('Chargement ajouté avec succès', false, 'Palette');
      return response;
    });
  }

  getAllPalettes(params) {
    return this.http
      .post(`${this.base_url}/total`, params, { headers: this.headers })
      .map((res) => {
        return JSON.parse(JSON.stringify(res));
      });
        
        
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/planning-palettes.service.ts